module.exports = __webpack_public_path__ + "img/block.d157bf40.svg";